/** Order Book & Forward Revenue — framed (full build is a follow-on: 1 Aug snapshots). */
import React from 'react'
import FramedSurface from './FramedSurface'
import Waterfall from '../components/kit/charts/Waterfall'
import { gbpK } from '../viewmodels/format'

export default function OrderBook(): React.JSX.Element {
  const chart = (
    <Waterfall
      steps={[
        { label: 'Opening', v: 3800, type: 'total' },
        { label: 'Added', v: 640 },
        { label: 'Slipped', v: -280 },
        { label: 'Pulled fwd', v: 180 },
        { label: 'Invoiced', v: -520 },
        { label: 'Closing', v: 3820, type: 'total' },
      ]}
      fmt={gbpK}
    />
  )
  return (
    <FramedSurface
      kicker="Order Book & Forward Revenue"
      kickerColor="var(--orange)"
      title="Order Book"
      desc="Forward demand profile, movement waterfall, past-due aging and an append-only snapshot timeline. Revenue basis (firm | blended | committed) is a first-class toggle; the hollow legacy “blended future” leg is replaced by honestly ingested demand."
      chartTitle="Movement waterfall · Added / Slipped / Pulled / Invoiced"
      chart={chart}
      notes={[
        { h: 'Hard date: 1 Aug 2026', p: 'The first real snapshot fires 1 Aug. Movement & aging views have no history until snapshots accumulate — the empty-then-filling state is designed deliberately.' },
        { h: 'Snapshot timeline', p: '1st-of-month + weekly, append-only, never backfillable. History is a fact, not a recomputation.' },
        { h: 'Revenue basis toggle', p: 'Firm / blended / committed relabels the chart; committed ships dark where no demand feed exists.' },
      ]}
    />
  )
}
